module.exports = __webpack_public_path__ + "static/img/qr_code.8b7d3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/qr_code.png
// module id = mI3V
// module chunks = 76